import { CountUp } from "../motion/CountUp";
import { useLanguage } from "../i18n/LanguageContext";

export default function About() {
  const { t, lang } = useLanguage();
  const stats = t("about.stats");

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#FFFFFF] border-y border-[#E5E3DB]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-start">
          <div className="col-span-12 md:col-span-5">
            <div className="eyebrow text-ink mb-4">{t("about.overline")} · 07</div>
            <picture>
              <source media="(min-width: 768px)" srcSet="/brand/kantoor-staand-v2.webp" width="800" height="1000" />
              <img
                src="/brand/kantoor-breed-v2.webp"
                width="1400"
                height="927"
                alt={lang === "en" ? "Ghio's office in Lemmer" : "Het kantoor van Ghio in Lemmer"}
                loading="lazy"
                decoding="async"
                data-testid="about-photo"
                className="block w-full h-auto aspect-[16/9] md:aspect-[4/5] object-cover"
              />
            </picture>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7">
            <h2 className="heading-display text-4xl md:text-5xl lg:text-6xl mb-8" data-testid="about-title">
              {t("about.title")}
            </h2>
            <div data-testid="about-body" className="space-y-5 text-base md:text-lg text-ink leading-relaxed mb-12 max-w-[560px]">
              {t("about.body").map((p) => <p key={p}>{p}</p>)}
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
              {stats.map((s, i) => {
                const inner = (
                  <>
                    <div className="heading-display text-4xl md:text-5xl"><CountUp text={s.k} testid={`about-stat-${i}-value`} /></div>
                    <div className="text-xs text-ink tracking-wide mt-1">{s.v}</div>
                  </>
                );
                return s.href ? (
                  <a key={s.k} href={s.href} target="_blank" rel="noopener" data-testid={`about-stat-${i}`} className="block border-t border-navy pt-4 hover:opacity-80 transition-opacity">{inner}</a>
                ) : (
                  <div key={s.k} data-testid={`about-stat-${i}`} className="border-t border-navy pt-4">{inner}</div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
